import "./css/Header.scss";

function Header() {
  return (
    <header className="Header position-relative">
      <div className="Header__greeting pt-5 px-3 position-absolute bottom-0 w-100 text-center text-light">
        <h1>Hi 👋, I'm Achuthan R</h1>
        <div className="mt-3 d-flex flex-column align-items-center">
          <p>Full Stack Software Engineer with more proficiency in backend with hands-on experience building scalable, high-performance systems using Java and Spring Boot. Proven ability to design and implement complex backend features and optimize database performance.</p>
          <p>Complementing a strong backend foundation, also proficient in React and TypeScript with experience building responsive and dynamic front-end projects.</p>
        </div>
      </div>
    </header>
  );
}

export default Header;